module.exports = __webpack_public_path__ + "img/main-consign-sfapp.09e8b36.webp";